import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import { Card, Button, Checkbox, Form, Modal, Upload, Icon, Input, Select, Spin, message } from "antd";
import _ from "lodash";
import BannerForm from "./BannerForm";
import Services from "../../../services/categories";
import CKEditor from 'ckeditor4-react';
import CategoryFormHelper from "./CategoryFormHelper";
const CategoryForm = (props) => {
  const history = useHistory();

  const { TextArea } = Input;
  const Option = Select.Option;
  const FormItem = Form.Item;

  let PreviewFromLink = {
    uid: "",
    name: "",
    status: "done",
    response: "ok",
    url: "",
  };

  const [slug, setSlug] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const [categoryStatus, setCategoryStatus] = useState(true);

  const [parentCategory, setParentCategory] = useState(true);
  const [selectedParent, setSelectedParent] = useState([]);
  const [categoryList, setCategoryList] = useState([]);

  const [title, setTitle] = useState("");
  const [keywords, setKeywords] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [shortDescription, setShortDescription] = useState("");
  const [content, setContent] = useState("");
  const [isFeatured, setIsFeatured] = useState("");

  const [previewImage, setPreviewImage] = useState(null);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [image, setImage] = useState("");
  const [fileList, setFileList] = useState([]);

  const [loading, setLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState({});
  const [bannersForEdit, setBannersForEdit] = useState([]);

  const [isSave, setIsSave] = useState(false);

  useEffect(() => {
    getInitialData();
  }, []);

  const getInitialData = async () => {
    const { match } = props;

    let { id } = match.params;
    const categories = await Services.getCategoryList();
    const categoryList = categories
      ?.map((item) => ({
        level: item.level,
        name: item.name,
        slug: item.slug,
        _id: item._id,
      }))
      .filter((item) => item.level <= 2 && id !== item._id);

    if (id) {
      const details = await Services.getCategoryDetails(id);

      const parent = details?.data?.parent;
      if (parent) {
        let parentArr = [];
        let indexArr = [];

        for (let i = 0; i < parent.length; i++) {
          let parentIndex = categoryList.findIndex(
            (category) => category._id === parent[i]
          );

          if (parentIndex !== -1) {
            parentArr.push(categoryList[parentIndex]);
            indexArr.push(parentIndex)
          }
        }

        setSelectedParent(parentArr);
        setParentCategory(indexArr);
      }

      setSlug(details?.data?.slug);
      setCategoryName(details?.data?.name);
      setCategoryStatus(details?.data?.isActive);
      setTitle(details?.data?.metaTitle);
      setKeywords(details?.data?.metaKeywords);
      setMetaDescription(details?.data?.metaDescription);
      setShortDescription(details?.data?.shortDescription);
      setContent(details?.data?.content);
      setIsFeatured(details?.data?.isFeatured);
      setImage(details?.data?.image);
      setFileList(details?.data?.image
        ? [
          {
            ...PreviewFromLink,
            uid: details?.data?.image,
            name: "",
            url: `/api/util/image?key=${details?.data?.image}`,
          },
        ]
        : []);
      setIsEdit(true);
      setEditData(details?.data || {});
      setBannersForEdit(details?.data?.banners || []);
      setIsSave(details?.data?.slug ? true : false);
    }

    setCategoryList(categoryList);
  }

  const onChange = (evt) => {
    const newContent = evt.editor.getData();
    setContent(newContent);
  }

  const handleCategoryName = (e) => {
    let slug = e.target.value.replace(/[^A-Za-z0-9-]/gi, "").toLowerCase();

    setSlug(slug);
    setCategoryName(e.target.value);
  };

  const handleSlug = (e) => {
    let slug = e.target.value.replace(/[^A-Za-z0-9-]/gi, "").toLowerCase();

    setSlug(slug);
  };

  const handleShortDescription = (e) => {
    setShortDescription(e.target.value);
  };

  const handleKeywords = (e) => {
    setKeywords(e.target.value);
  };

  const handleTitle = (e) => {
    setTitle(e.target.value);
  };

  const handleMetaDescription = (e) => {
    setMetaDescription(e.target.value);
  };

  const handleCategoryStatus = (val) => {
    setCategoryStatus(val);
  };

  const handleParentCategory = (val) => {
    setParentCategory(val);
    let multiParent = [];
    for (let i = 0; i < val.length; i++) {
      multiParent.push(categoryList[val[i]])
    }
    setSelectedParent(multiParent);
  };

  const onCheckFeatured = (e) => {
    setIsFeatured(e.target.checked);
  };

  const handlePreview = (file) => {
    setPreviewImage(file.url || file.thumbUrl);
    setPreviewVisible(true);
  };

  const handleCancel = () => setPreviewVisible(false);

  const handleRemove = () => {
    setImage([]);
  };

  const customRequest = async ({ file, onSuccess }) => {
    setImage(file);
    setTimeout(() => onSuccess("ok"), 0);
  };

  const handleChange = ({ file, fileList }) => {
    setFileList(fileList)
  };

  const onPreview = () => {
    const url = `http://cmsplatform-web.herokuapp.com/${slug}`
    isSave && window.open(url, '_blank');
  }

  const onSubmit = async () => {

    if (slug && slug.length <= 2) {
      message.warning("Slug must be more than 2 characters");
      return;
    }
    if (
      !slug ||
      !title ||
      !keywords ||
      !metaDescription ||
      !content ||
      !categoryName
    ) {
      message.error("Please insert all required fields");
      return;
    }

    setLoading(true);
    const bannerState = CategoryFormHelper.getBannerState();

    let thumbIMG;
    if (image) {
      thumbIMG = await Services.uploadToS3({ file: image });
      Promise.resolve(thumbIMG);
    }

    const UploadedBannner = await Promise.all(
      bannerState.banner?.fields?.map(async (item, index) => {
        if (!bannerState?.images[index]) {
          return {
            _id: bannerState.banner?._id[index],
            title: bannerState.banner?.title[index],
            url: bannerState.banner?.url[index],
          };
        }

        let file = bannerState?.images[index];
        let response;

        if (!!file) {
          response = await Services.uploadToS3({ file: file });
          Promise.resolve(response);
        }
        return {
          fileName: response?.fileName,
          originalName: response?.originalName,
          title: bannerState.banner?.title[index],
          url: bannerState.banner?.url[index],
          _id: bannerState.banner?._id[index],
        };
      })
    );
    const { match } = props;

    let { id } = match.params;

    if (isEdit && !id) {
      message.error("Category id is missing");
      return;
    }

    let categoryResponse;
    try {
      if (!isEdit) {
        categoryResponse = await Services.addCategory({
          slug,
          categoryStatus,
          parentCategory: selectedParent,
          title,
          keywords,
          description: metaDescription,
          shortDescription,
          content,
          categoryName,
          banners: UploadedBannner || [],
          isFeatured,
          image: thumbIMG?.fileName
        });
      } else {

        categoryResponse = await Services.editCategory({
          categoryId: id,
          slug,
          categoryStatus,
          parentCategory: selectedParent,
          title,
          keywords,
          description: metaDescription,
          shortDescription,
          content,
          categoryName,
          banners: UploadedBannner || [],
          isFeatured,
          image: thumbIMG?.fileName
        });
      }
    } catch (e) {
      message.error(e.response.data.error);
    }

    if (categoryResponse?.status == 200) {
      setLoading(false);
      message.success("Saved!");
      setIsSave(true);
      // history.push("/categories")
    } else {
      setLoading(false);
    }
  };

  const stateSetter = (stateName, stateValue) => {
    this.setState({
      [stateName]: stateValue,
    });
  };


  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
  };

  const children = [];
  for (let i = 1; i < 10; i++) {
    children.push(<Option key={i.toString(36) + i}>{"test"}</Option>);
  }

  // MULTIPLE-scripts End
  const uploadButton = (
    <div>
      <Icon type="plus" />
      <div className="ant-upload-text">Upload</div>
    </div>
  );

  return (
    <Spin spinning={loading} size="large">
      <div className="menu-editor-box card-pad-new menu-cate-list users-main-page categoryForm-main">
        <div className="payout-report-box">
          <Card className="gx-card breadcrumb-box" title="">
            <div className="ant-row hd-title">
              <div className="ant-col-md-12">
                <h1>Manage Category</h1>
              </div>
              <div className="ant-col-md-12 rite-btn d-none">
                <Button type="primary" className="color-white">
                  {" "}
                    Create
                  </Button>
              </div>
              <div className="ant-col-md-12">
                <div className="orders-item top-section filter-box ">
                  <div className="drop-filter-cover">
                    <Select
                      className="select-box"
                      defaultValue={"Select"}
                      value={categoryStatus}
                      onChange={handleCategoryStatus}
                    >
                      <Option value={true}> Enabled</Option>
                      <Option value={false}>Disabled</Option>
                    </Select>
                  </div>
                </div>
              </div>
            </div>
            <div className="ant-row gx-mt-4">
              <div className="ant-col-md-24">
                <div className="item-detail-edit-box">
                  <div className="ant-row">
                    <div className="ant-col-md-12">
                      <FormItem
                        {...formItemLayout}
                        labelAlign="left"
                        label={<span><span style={{ color: "red" }}>*</span>Category Name</span>}
                      >
                        <Input
                          type="text"
                          placeholder="Category Name"
                          value={categoryName}
                          onChange={handleCategoryName}
                        />
                      </FormItem>
                    </div>

                    <div className="ant-col-md-12">
                      <FormItem
                        {...formItemLayout}
                        labelAlign="left"
                        label="Parent Category"
                      >
                        <Select
                          value={parentCategory}
                          mode="multiple"
                          placeholder="Parent Category"
                          optionFilterProp="children"
                          onChange={handleParentCategory}
                          showSearch
                          filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        >
                          <Option value={true}>{"No Parent"}</Option>
                          {categoryList.map((item, i) => {
                            return (
                              <Option key={i} value={i}>
                                {item.name}
                              </Option>
                            );
                          })}
                        </Select>
                      </FormItem>
                    </div>

                  </div>
                  <div className="ant-row gx-mt-4">
                    <div className="ant-col-md-8">
                      <FormItem
                        {...formItemLayout}
                        labelAlign="left"
                        label={<span><span style={{ color: "red" }}>*</span>Slug/URL</span>}

                      >
                        <Input
                          type="text"
                          placeholder="Slug/URL"
                          onChange={handleSlug}
                          value={slug}
                        />
                      </FormItem>
                    </div>

                    <div className="ant-col-md-8">
                      <FormItem
                        {...formItemLayout}
                        labelAlign="left"
                        label={<span><span style={{ color: "red" }}>*</span>Meta Keywords</span>}
                      >
                        <Input
                          type="text"
                          placeholder="Meta Keywords"
                          onChange={handleKeywords}
                          value={keywords}
                        />
                      </FormItem>
                    </div>

                    <div className="ant-col-md-8">
                      <FormItem
                        {...formItemLayout}
                        labelAlign="left"
                        label={<span><span style={{ color: "red" }}>*</span>Meta Title</span>}
                      >
                        <Input
                          type="text"
                          placeholder="Meta Title"
                          onChange={handleTitle}
                          value={title}
                        />
                      </FormItem>
                    </div>
                  </div>
                  <div className="ant-row gx-mt-4">
                    <div className="ant-col-md-16">
                      <FormItem
                        {...formItemLayout}
                        labelAlign="left"
                        label={<span><span style={{ color: "red" }}>*</span>Meta Description</span>}
                      >
                        <TextArea
                          rows={3}
                          placeholder="Meta Description"
                          onChange={handleMetaDescription}
                          value={metaDescription}
                        />
                      </FormItem>
                    </div>

                    <div className="ant-col-md-8">
                      <FormItem
                        {...formItemLayout}
                        labelAlign="left"
                        label={<span><span style={{ color: "red" }}></span>Short Description</span>}
                      >
                        <Input
                          type="text"
                          placeholder="Short Description"
                          value={shortDescription}
                          onChange={handleShortDescription}
                        />
                      </FormItem>
                    </div>

                    <div className="ant-col-md-8">
                      <FormItem
                        {...formItemLayout}
                        labelAlign="left"
                        label="Action"
                      >
                        <Checkbox
                          checked={isFeatured}
                          onChange={onCheckFeatured}
                        >
                          Featured
                        </Checkbox>
                      </FormItem>
                    </div>
                  </div>

                  <div className="ant-row gx-mt-4">
                    <div className="ant-col-md-24">
                      <FormItem
                        {...formItemLayout}
                        labelAlign="left"
                        label={<span><span style={{ color: "red" }}>*</span>Content</span>}
                      >
                        <CKEditor
                          activeClass="p10"
                          data={content}
                          config={{
                            //allowedContent: 'p b i s li ul ol h1 h2 bulletedList numberedlist',
                            extraPlugins: "colorbutton",
                            removePlugins: 'horizontalrule,blockquote,sourcearea,pasteFromWord',
                            removeButtons:
                              "Subscript,Superscript,Underline,Image,Save,NewPage,Preview,Print,Templates,Cut,Copy,Paste,PasteText,PasteFromWord,Find,SelectAll,Scayt,Replace,Form,Checkbox,Textarea,Select,Button,ImageButton,HiddenField,CreateDiv,BidiLtr,BidiRtl,Language,Flash,Smiley,SpecialChar,PageBreak,Iframe,Anchor,ShowBlocks,About,CopyFormatting,Undo,Redo",
                          }}
                          onChange={onChange}
                        />
                      </FormItem>
                    </div>
                  </div>

                  <div className="ant-row gx-mt-4">
                    <div className="ant-col-md-24">
                      <div className="ant-row hd-title gx-m-0">
                        <div className="ant-col-md-12">
                          <h1>Thumbnail Image</h1>
                        </div>
                      </div>
                      <div className="ant-row gx-mt-4">
                        <div className="ant-col-md-24">
                          <div className="item-detail-edit-box">
                            <div className="ant-row">
                              <div className="ant-col-md-4 upload-img-main">
                                <Upload
                                  listType="picture-card"
                                  fileList={fileList}
                                  onPreview={handlePreview}
                                  customRequest={customRequest}
                                  onChange={handleChange}
                                  onRemove={handleRemove}
                                  accept="image/jpeg, image/png"
                                >
                                  {fileList?.length ? null : uploadButton}
                                </Upload>
                                <Modal
                                  visible={previewVisible}
                                  footer={null}
                                  onCancel={handleCancel}
                                >
                                  <img
                                    alt=""
                                    style={{ width: "100%" }}
                                    src={previewImage}
                                  />
                                </Modal>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="ant-row gx-mt-4">
                    <div className="ant-col-md-24">
                      <BannerForm
                        editFormBanners={isEdit ? bannersForEdit : []}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Card>
          <div className="ant-row gx-m-0 btn-right">
            <div className="ant-row gx-m-0 btn-left">
              <Button
                type="danger"
                className="color-white"
                onClick={history.goBack}
              >
                Back
                </Button>
            </div>

            <Button
              type="primary"
              className="color-white"
              onClick={onPreview}
              disabled={!isSave}
            >
              Preview
              </Button>
            {
              !isSave && <span style={{ color: "red" }}>*Preview not available</span>
            }

            <Button
              type="primary"
              className="color-white"
              onClick={onSubmit}
            >
              Save
              </Button>
          </div>
        </div>
      </div>
    </Spin>
  );
}

export default CategoryForm;